import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAddToCart();
    window.location.href = 'https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1';
  };
  return <section className="w-full bg-gradient-to-b from-cream to-white py-12 md:py-20 px-4" data-id="element-45">
      <div className="max-w-7xl mx-auto" data-id="element-46">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-47">
          {/* Left Column - Text Content */}
          <div className="text-center md:text-left" data-id="element-48">
            <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-gray-900 leading-tight mb-4" data-id="element-49">
              Aprende crochet desde cero y crea piezas que puedes vender desde
              casa
            </h1>
            <p className="font-heading text-xl md:text-2xl text-gray-600 italic mb-6" data-id="element-50">
              (aunque hoy no entiendas los patrones)
            </p>
            <p className="font-body text-lg md:text-xl text-gray-700 leading-relaxed mb-8" data-id="element-51">
              Descubre el método paso a paso que ya ayudó a cientos de mujeres a
              dejar la frustración y empezar a crear tejidos hermosos desde el
              primer día.
            </p>
            <a href="https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1" onClick={handleCTAClick} className="inline-block w-full md:w-auto bg-primary hover:bg-opacity-90 text-white font-heading font-bold text-lg px-12 py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105" data-id="element-52">
              COMPRAR AHORA
            </a>

            {/* Trust Badges */}
            <div className="mt-8 flex flex-wrap justify-center md:justify-start items-center gap-4" data-id="element-53">
              <div className="flex items-center gap-1" data-id="element-54">
                <span className="text-accent text-xl" data-id="element-55">⭐⭐⭐⭐⭐</span>
              </div>
              <span className="font-body text-sm text-gray-600" data-id="element-56">
                +3.700 tejedoras satisfechas
              </span>
            </div>
          </div>

          {/* Right Column - Hero Image */}
          <div className="relative" data-id="element-57">
            <div className="aspect-square bg-gradient-to-br from-primary/20 to-secondary/20 rounded-3xl shadow-2xl overflow-hidden" data-id="element-58">
              <img src="https://images.unsplash.com/photo-1611171711912-e0e5b7f0e9b3?w=800&h=800&fit=crop" alt="Hermosos amigurumis tejidos a crochet" className="w-full h-full object-cover" data-id="element-59" />
            </div>
            {/* Floating Badge */}
            <div className="absolute -top-4 -right-4 bg-accent text-gray-900 font-heading font-bold px-6 py-3 rounded-full shadow-xl transform rotate-12" data-id="element-60">
              <p className="text-sm" data-id="element-61">+7.000</p>
              <p className="text-xs" data-id="element-62">Patrones</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}